import { useDispatch } from '@/hooks/dispatch'
import { actionCreators as myTasksActionCreators } from '@/store/myTasks'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import React, { useCallback, useEffect, useState } from 'react'
import { dialogTypes } from '@/dialogs'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import context from '@/context'

function ReassignTaskButton ({ className, task }) {
  const isGranted = usePermissionChecker()
  const [canReassign, setCanReassign] = useState(false)
  const [updateAssignedTo, openDialog] = useDispatch([myTasksActionCreators.updateAssignedTo, dialogActions.openDialog])

  const { id, ticketId, assignedTo, assignedToUserId, status } = task

  const onClickReassign = useCallback(() => {
    openDialog({
      dialogType: dialogTypes.userSelector,
      value: { makerUserId: assignedToUserId, makerUser: { id: assignedToUserId, name: assignedTo } },
      onAction: (value) => updateAssignedTo(id, value)
    })
  }, [updateAssignedTo, id, assignedTo, assignedToUserId, openDialog])

  useEffect(() => {
    if (status !== workflowTaskStatus.enum.Closed) {
      if (!isGranted('CanReassignTask')) {
        context.api.userManagementService.getUserForUserProfile().then(user => {
          if (task.assignedToUserId !== user.id) {
            context.api.ticketService.get(ticketId).then(ticket => {
              setCanReassign(ticket.authorId === user.id)
            }).catch(() => setCanReassign(false))
          } else {
            setCanReassign(true)
          }
        }).catch(() => setCanReassign(false))
      } else {
        setCanReassign(true)
      }
    }
  }, [status, ticketId, isGranted, task.assignedToUserId])

  return canReassign && (
    <button type={'button'} className={className} onClick={onClickReassign}>
      <Icon name='pencil' />&nbsp;
      <Resx name='TaskButtons.Reassign' />
    </button>
  )
}

export {
  ReassignTaskButton
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/reassignTaskButton.js